import { AppRoutes } from "@/shared/lib/routes"
import { createRoute, redirect } from "@tanstack/react-router"
import { rootRoute } from "./__root"
import { getEffectiveParam } from "@/features/config"
import { LandingPage } from "@/features/landing"

export const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: AppRoutes.HOME,
  // A funnel can send users straight into the quiz instead of the landing page
  // via `landing=quiz` (config or URL). Config is bootstrapped before the router
  // mounts, so the param is already available here. URL search is preserved.
  beforeLoad: ({ location }) => {
    if (getEffectiveParam("landing") === "quiz") {
      throw redirect({ to: AppRoutes.QUIZ, search: location.search, replace: true })
    }
  },
  component: LandingPage,
})
